import { FormattedMessage } from 'react-intl';
import React from 'react';

export const contractsColumns = {
  state: {
    id: 'state',
    label: <FormattedMessage id={'app.pages.customerListPage.state'} />,
    width: '5%',
    align: 'left',
    options: {
      sortable: true,
      filterable: true,
    },
  },
  sapId: {
    id: 'sapId',
    label: <FormattedMessage id={'app.users.sapId'} />,
    width: '50px',
  },
  frameContract: {
    id: 'frameContract',
    label: <FormattedMessage id={'app.contracts.frameContract'} />,
    width: '100px',
  },
  contract: {
    id: 'contract',
    label: <FormattedMessage id={'app.contracts.contractName'} />,
    options: {
      sortable: true,
    },
    width: '100px',
  },
  commodity: {
    id: 'commodity',
    label: <FormattedMessage id={'app.contracts.commodity'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '70px',
  },
  contractPeriod: {
    id: 'period',
    label: <FormattedMessage id={'app.contracts.contractPeriod'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '145px',
  },
  product: {
    id: 'product',
    label: <FormattedMessage id={'app.contracts.product'} />,
    options: {
      sortable: true,
    },
    width: '50px',
  },
  purchaseMethod: {
    id: 'purchaseMethod',
    label: <FormattedMessage id={'app.contracts.purchaseMethod'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '195px',
  },
  productType: {
    id: 'isMonthlyPurchaseAvailable',
    label: <FormattedMessage id={'app.billingprices.product'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '150px',
  },
  contractNumber: {
    id: 'contractNumber',
    label: <FormattedMessage id={'app.contracts.contractNumber'} />,
    options: {
      sortable: true,
    },
    width: '150px',
  },
  organisation: {
    id: 'organizationName',
    label: <FormattedMessage id={'app.contracts.organisation'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '200px',
  },

  companyID: {
    id: 'companyID',
    label: <FormattedMessage id={'app.contracts.companyID'} />,
    options: {
      sortable: true,
    },
    width: '100px',
  },
  kam: {
    id: 'kam',
    label: <FormattedMessage id={'app.contracts.kam'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '150px',
  },
  purchasedPercent: {
    id: 'percentagePurchasedQuantity',
    label: <FormattedMessage id={'app.contracts.purchasedPercent'} />,
    options: {
      sortable: true,
    },
    width: '200px',
  },
  purchased: {
    id: 'purchased',
    label: <FormattedMessage id={'app.contracts.purchased'} />,
    options: {
      sortable: true,
    },
    align: 'right',
    width: '200px',
  },
  volume: {
    id: 'quantity',
    label: <FormattedMessage id={'app.contracts.volume'} />,
    options: {
      sortable: true,
    },
    align: 'right',
    width: '125px',
  },
  remains: {
    id: 'remainingPurchaseQuantity',
    label: <FormattedMessage id={'app.contracts.remains'} />,
    options: {
      sortable: true,
    },
    align: 'right',
    width: '120px',
  },
  idExternal: {
    id: 'idExternal',
    label: <FormattedMessage id={'app.contracts.contractNumber'} />,
    width: '100px',
  },
  currency: {
    id: 'currency',
    label: <FormattedMessage id={'app.contracts.currency'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '50px',
  },

  invoicingCurrency: {
    id: 'invoicingCurrency',
    label: <FormattedMessage id={'app.contracts.invoicingCurrency'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '100px',
  },

  deliveryProduct: {
    id: 'supplyProduct',
    label: <FormattedMessage id={'app.contracts.deliveryProduct'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '145px',
  },
  pnMethod: {
    id: 'purchaseIndexType',
    label: <FormattedMessage id={'app.contracts.pnMethod'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '115px',
  },
  priceType: {
    id: 'priceSource',
    label: <FormattedMessage id={'app.contracts.priceType'} />,
    options: {
      sortable: true,
      filterable: true,
    },
    width: '90px',
  },
  reversePurchase: {
    id: 'isSale',
    label: <FormattedMessage id={'app.contracts.reversePurchase'} />,
    options: {
      sortable: true,
    },
    width: '108px',
  },
  remains1: {
    id: 'remainingPurchaseQuantityM1',
    label: <FormattedMessage id={'app.contracts.remainsM1'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '130px',
  },
  remains2: {
    id: 'remainingPurchaseQuantityM2',
    label: <FormattedMessage id={'app.contracts.remainsM2'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '130px',
  },
  remains3: {
    id: 'remainingPurchaseQuantityM3',
    label: <FormattedMessage id={'app.contracts.remainsM3'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '130px',
  },
  remains4: {
    id: 'remainingPurchaseQuantityM4',
    label: <FormattedMessage id={'app.contracts.remainsM4'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '130px',
  },
  remains5: {
    id: 'remainingPurchaseQuantityM5',
    label: <FormattedMessage id={'app.contracts.remainsM5'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '130px',
  },
  remains6: {
    id: 'remainingPurchaseQuantityM6',
    label: <FormattedMessage id={'app.contracts.remainsM6'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '130px',
  },
  remains7: {
    id: 'remainingPurchaseQuantityM7',
    label: <FormattedMessage id={'app.contracts.remainsM7'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '130px',
  },
  remains8: {
    id: 'remainingPurchaseQuantityM8',
    label: <FormattedMessage id={'app.contracts.remainsM8'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '130px',
  },
  remains9: {
    id: 'remainingPurchaseQuantityM9',
    label: <FormattedMessage id={'app.contracts.remainsM9'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '130px',
  },
  remains10: {
    id: 'remainingPurchaseQuantityM10',
    label: <FormattedMessage id={'app.contracts.remainsM10'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '135px',
  },
  remains11: {
    id: 'remainingPurchaseQuantityM11',
    label: <FormattedMessage id={'app.contracts.remainsM11'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '135px',
  },
  remains12: {
    id: 'remainingPurchaseQuantityM12',
    label: <FormattedMessage id={'app.contracts.remainsM12'} />,
    options: {
      sortable: false,
    },
    align: 'right',
    width: '135px',
  },
};
